import { ReactNode, useCallback, useEffect, useState } from 'react';
import { ReminderContext } from '../contexts/ReminderContext';
import { AccountReminderNotification } from '../components/account/reminder/AccountReminderNotification.tsx';
import { IReminderEvent } from '../interfaces/account/reminder/IReminderEvent.ts';

export const AccountReminderProvider = ({ children }: { children: ReactNode }) => {
    // const { user, setUser } = useAuth();

    const [isVisible, setIsVisible] = useState(false);
    const [reminderQueue, setReminderQueue] = useState<IReminderEvent[]>([]);
    const [currentReminder, setCurrentReminder] = useState<IReminderEvent | null>(null);

    const addReminder = useCallback((newReminder: IReminderEvent) => {
        setReminderQueue(prevQueue => {
            if (prevQueue.some(reminder => reminder.id === newReminder.id)) {
                return prevQueue;
            }
            return [...prevQueue, newReminder];
        });
    }, []);

    // const updateReminderAsDisplayed = (reminder: IReminder) => {
    //     setReminderQueue(prevUser => {
    //         if (!prevUser) return prevUser;
    //
    //         return {
    //             ...prevUser,
    //             ...prevUser.map(r =>
    //                 r.id === reminder.id ? { ...r, isDisplayed: true } : r
    //             )
    //         };
    //     });
    // };

    // const showReminder = (reminder: IReminder) => {
    //     setReminder(reminder);
    //     setIsVisible(true);
    // };
    //
    // const closeReminder = () => {
    //     setIsVisible(false);
    //     setReminder(null);
    // };
    //
    // const isTimeToShowReminder = (reminder: IReminder): boolean => {
    //     var currentTime = new Date();
    //     currentTime.setSeconds(currentTime.getSeconds() + 10);
    //
    //     if (reminder.remindAt <= currentTime)
    //         return true;
    //     return false;
    // };

    // const checkForReminder = () => {
    //     var currentTime = new Date();
    //     var inFutureReminders = user?.reminders.filter(reminder => reminder.remindAt >= currentTime);
    //     // console.log("reminders ", user);
    //     // inFutureReminders?.forEach(reminder =>
    //     //     // console.log(currentTime, reminder.remindAt)
    //     // );
    //
    //     inFutureReminders?.forEach(reminder => {
    //         if (isTimeToShowReminder(reminder)) {
    //             // console.log("show");
    //             showReminder(reminder);
    //             updateReminder(reminder);
    //         }
    //     });
    // };

    // useEffect(() => {
    //     // console.log("reminder interval before", user);
    //
    //     let intervalId: NodeJS.Timeout;
    //     if (user && user.reminders && user.reminders.length > 0) {
    //         intervalId = setInterval(() => {
    //             // console.log("reminder interval");
    //             checkForReminder();
    //         }, 5000);
    //     }
    //     return () => {
    //         if (intervalId)
    //             clearInterval(intervalId);
    //     };
    // }, [user?.reminders]);

    // useEffect(() => {
    //     if (isVisible) {
    //         setTimeout(() => {
    //             closeReminder();
    //         }, 30000);
    //     }
    // }, [isVisible]);

    const showNextReminder = useCallback(() => {
        setReminderQueue(prev => {
            if (prev.length === 0) {
                setCurrentReminder(null);
                setIsVisible(false);
                return prev;
            }

            const next = prev[0];
            setCurrentReminder(next);
            setIsVisible(true);

            return prev.slice(1); // usuwamy z kolejki
        });
    }, []);

    const closeReminder = useCallback(() => {
        setIsVisible(false);
        // Po animacji zamykania pokazujemy następny
        setTimeout(() => {
            showNextReminder();
        }, 300);
    }, [showNextReminder]);

    useEffect(() => {
        let timeout: NodeJS.Timeout | null = null;

        if (isVisible && currentReminder) {
            timeout = setTimeout(() => {
                closeReminder();
            }, 300000);
        }

        return () => {
            if (timeout) clearTimeout(timeout);
        };
    }, [isVisible, currentReminder, closeReminder]);

    useEffect(() => {
        if (!isVisible && reminderQueue.length > 0) {
            showNextReminder();
        }
    }, [isVisible, reminderQueue.length, showNextReminder]);


    return (
        <ReminderContext.Provider value={{ addReminder, closeReminder, isVisible, reminder: currentReminder }}>
            <AccountReminderNotification />
            {children}
        </ReminderContext.Provider>
    );
};
